import { createSlice } from "@reduxjs/toolkit";

interface DatosEncuesta {
    activo: string;
    cveTipoEncuesta: number;
    objetivoEncuesta: string;
    destinatarioEncuesta: string;
    fechaActualizacion: string;
    fechaFin: string;
    fechaInicio: string;
    fechaRegistro: string;
    idEncuesta: number;
    nombreEncuesta: string;
}
interface Respuestas {
    idPregunta: number;
    idRespuesta: number;
    descripcion: string;
    despliega: string;
}
interface Preguntas {
    pregunta: string,
    idPregunta: number,
    idPreguntaPadre: number,
    cveSeccion: number,
    respuestas: Respuestas[]
}
interface initialStateI {
    isEncuestaOpen: boolean;
    isActiva:boolean;
    preguntas: Preguntas[];
    lstRespuestas: any[];
    respUsuario: any[];
    datosEncuesta: DatosEncuesta | null;
    preguntasHijas: Preguntas[];

}

const initialState: initialStateI = {
    isEncuestaOpen: false,
    isActiva:false,
    preguntas: [],
    lstRespuestas: [],
    respUsuario: [],
    datosEncuesta: null,
    preguntasHijas: [],

};

export const encuestaCalidadSlice = createSlice({
    name: "encuestaCalidad",
    initialState,
    reducers: {
        onEncuestaOpen: (state, { payload }) => {
            state.isEncuestaOpen = payload;
        },
        onActiva: (state, { payload }) => {
            state.isActiva = payload;
        },
        onPregunta: (state, { payload }) => {
            state.preguntas = payload;
        },
        onLstRespuesta: (state, { payload }) => {
            state.lstRespuestas = payload;
        },
        onRespUsuario: (state, { payload }) => {
            state.respUsuario = payload;
        },
        onDatosEncuesta: (state, { payload }) => {
            state.datosEncuesta = payload;
        },
        onPreguntasHijas: (state, { payload }) => {
            state.preguntasHijas = payload;
        },
    },
});

export const {
    onEncuestaOpen,
    onActiva,
    onPregunta,
    onLstRespuesta,
    onRespUsuario,
    onDatosEncuesta,
    onPreguntasHijas
} = encuestaCalidadSlice.actions;

export default encuestaCalidadSlice.reducer;
